import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Title, Fieldset, Button, Control, Field } from "rbx";
import { useMutation } from "react-apollo";

import { CREATE_ITEM_MUTATION } from "../../graphql/Items/Items.graphql";
import { formatCurrency, unmaskCurrency, ourToast as toast } from "../../utils";
import { useCompanyParameters, useSystemCodes } from "../../utils/hooks";
import { useAuthorization } from "../Authorization";
import Loading from "../Loading";
import ItemForm from "./ItemForm";

const DEFAULT_STATE = {
  Active: true,
  Description: "",
  ItemNo: "",
  StdCost: 0,
  AvgCost: 0,
  ListPrice: 0,
  MinQty: "",
  MaxQty: "",
  AllowDiscounts: true,
  ItemCatgRecIdRef: "",
  InvGLRecIdRef: "",
  CogsGLRecIdRef: ""
};

const AddItemForm = ({ onComplete }) => {
  const auth = useAuthorization(["ADMIN", "MGMNT"]);
  const [inputs, setInputs] = useState({ ...DEFAULT_STATE });
  const [codes, setCodes] = useState(null);
  const { data: systemCodes } = useSystemCodes({
    Category: "General Ledger",
    CodeName: "AcctType"
  });

  useEffect(() => {
    if (!codes && Array.isArray(systemCodes)) {
      setCodes({
        asset: systemCodes.find(c => c.CodeId === "A"),
        expense: systemCodes.find(c => c.CodeId === "E")
      });
    }
  }, [codes, systemCodes]);

  const { data: CompanySettings = {} } = useCompanyParameters();
  const handleChange = e => {
    let value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    if (
      e.target.name === "StdCost" ||
      e.target.name === "AvgCost" ||
      e.target.name === "ListPrice"
    ) {
      const unmaskedValue = unmaskCurrency(e.target.value);
      value = formatCurrency(unmaskedValue);
    }
    setInputs({ ...inputs, [e.target.name]: value });
  };
  const [createItem, { loading }] = useMutation(CREATE_ITEM_MUTATION);
  const handleSave = async e => {
    e.preventDefault();
    try {
      await createItem({
        variables: {
          data: {
            ...inputs,
            ItemCatgRecIdRef: inputs.ItemCatgRecIdRef
              ? parseInt(inputs.ItemCatgRecIdRef)
              : null,
            MinQty: inputs.MinQty ? parseFloat(inputs.MinQty) : "",
            MaxQty: inputs.MaxQty ? parseFloat(inputs.MaxQty) : "",
            StdCost: inputs.StdCost
              ? parseFloat(unmaskCurrency(inputs.StdCost))
              : 0,
            AvgCost: inputs.AvgCost
              ? parseFloat(unmaskCurrency(inputs.AvgCost))
              : 0,
            ListPrice: inputs.ListPrice
              ? parseFloat(unmaskCurrency(inputs.ListPrice))
              : 0,
            InvGLRecIdRef: inputs.InvGLRecIdRef
              ? parseInt(inputs.InvGLRecIdRef)
              : null,
            CogsGLRecIdRef: inputs.CogsGLRecIdRef
              ? parseInt(inputs.CogsGLRecIdRef)
              : null
          }
        },
        refetchQueries: [
          "ALL_ITEMS_VIEW_QUERY_BY_PAGE_QUERY",
          "ALL_ITEMS_QUERY"
        ]
      });
      toast.success("Item created successfully.");
      onComplete();
    } catch (err) {
      console.log(err.message);
    }
  };

  if (!codes) return <Loading />;

  return (
    <form className="add-item-form" id="add-item-form" onSubmit={handleSave}>
      <Title>Create Item</Title>
      <Fieldset disabled={loading}>
        <ItemForm
          CompanySettings={CompanySettings}
          auth={auth}
          codeStates={codes}
          inputs={inputs}
          onChange={handleChange}
        />
        <hr />
        <Field kind="group">
          <Control>
            <Button color="primary" form="add-item-form" type="submit">
              Submit
            </Button>
          </Control>
          <Control>
            <Button type="button" onClick={onComplete}>
              Cancel
            </Button>
          </Control>
        </Field>
      </Fieldset>
    </form>
  );
};

AddItemForm.propTypes = {
  onComplete: PropTypes.func
};
export default AddItemForm;
